import { useNavigate } from "../contexts/AppContext";

export function NotFound() {
  const navigate = useNavigate();
  return (
    <div class="min-vh-100 d-flex flex-column align-items-center justify-content-center p-4">
      <div class="text-center">
        <h1 class="display-1 fw-bold text-muted">404</h1>
        <p class="lead mb-4">Page not found.</p>
        <a
          class="btn btn-primary"
          href="/"
          onClick={(e: Event) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <i class="bi bi-house"></i> Go home
        </a>
      </div>
    </div>
  );
}
